import { Fragment } from 'react';
import styled from 'styled-components';
import Range, { RangeSteps } from '../Range';
import RadioButton from '../RadioButton';

const Sliders = styled.div`
  display: grid;
  grid-template-columns: 40% max-content 1fr min-content;
  align-items: center;
  grid-row-gap: 2rem;
  grid-column: 1;
`;

const Label = styled.label(({ theme }) => {
  const { color, type } = theme;

  return `
    grid-column: 1;
    font-weight: ${type.weight.bold};
    color: ${color.grayscale[0]};
    text-align: left;
  `;
});

const LabelNote = styled.span(({ theme }) => {
  const { color, type } = theme;

  return `
    font-weight: ${type.weight.regular};
    color: ${color.grayscale[200]};
    display: block;
  `;
});

const Slider = styled(Range)`
  grid-column: 3;
`;

const Value = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    padding: 0 0 0 0.5rem;
    grid-column: 4;
    min-width: 3rem;
    text-align: left;
    font-weight: ${type.weight.regular};
    color: ${color.grayscale[0]};
  `;
});

const Fieldset = styled.fieldset`
  display: flex;
  flex-flow: row nowrap;
  border: 0;
  padding: 0;
  position: relative;
  padding-left: 50%;
  grid-column: 1 / span 4;
  padding-left: 40%;
  margin: 0;
`;

const Legend = styled.legend(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[0]};
    font-weight: ${type.weight.bold};
    font-size: ${type.size.regular};
    position: absolute;
    display: block;
    left: 0;
    text-align: left;
    width: 40%;
  `;
});

const Steps = styled(RangeSteps)`
  grid-column: 3;
  margin-bottom: -1.1875rem;
`;

const NotApplicableContainer = styled.div`
  grid-column: 2;
  padding-right: 2rem;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  input {
    top: 0;
  }
`;

const Checkbox = styled.input`
  width: 20px;
  height: 20px;
  position: relative;
  top: 3px;
`;

const CheckboxLabel = styled.label`
  margin-left: 5px;
  margin-bottom: 0;
`;

const AssistanceDetails = ({ className, inputs }) => {
  const inputLoop = inputs.map((input) => {
    let loop;

    if (input.type === 'range') {
      loop = (
        <Fragment key={input.name}>
          <Label htmlFor={input.name}>
            {input.label}
            {input.note && <LabelNote>{input.note}</LabelNote>}
          </Label>

          {input.showNotApplicable && (
            <NotApplicableContainer>
              <Checkbox
                name={`${input.name}_na`}
                id={`${input.name}_na`}
                type="checkbox"
                disabled
                checked={input.value === null}
              />
              <CheckboxLabel htmlFor={`${input.name}_na`}>N/A</CheckboxLabel>
            </NotApplicableContainer>
          )}

          <div>
            {input.showSteps && <RangeSteps steps={input.showSteps} />}

            <Slider
              showBackfill={input.showBackfill}
              name={input.name}
              disabled
              value={input.value === null ? 0 : input.value}
            />
          </div>

          {input.showValue && <Value>{input.value}%</Value>}
        </Fragment>
      );
    }

    if (input.type === 'radio') {
      const radioLoop = input.options.map((option) => {
        return (
          <RadioButton
            name={input.name}
            value={option.value}
            label={option.display}
            key={`${input.name}_${option.value}`}
            checked={input.value === option.value}
            disabled
          />
        );
      });

      loop = (
        <Fieldset key={`${input.name}_fieldset`}>
          <Legend>{input.label}</Legend>

          {radioLoop}
        </Fieldset>
      );
    }

    return loop;
  });

  return (
    <Sliders className={className}>
      <Steps steps={['0%', '25%', '50%', '75%', '100%']} />

      {inputLoop}
    </Sliders>
  );
};

export default AssistanceDetails;
